import { makeStyles } from '@material-ui/core/styles'
import { GRAY_COLORS, INFO_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  eventsContainer: { paddingTop: theme.spacing(1) },
  item: { marginBottom: theme.spacing(2) },
  inputLabel: {
    marginBottom: 5
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 16,
    gap: 12
  },
  icon: { marginRight: theme.spacing(2) },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: INFO_COLORS[700],
    cursor: 'pointer'
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 400,
    color: GRAY_COLORS[600],
    cursor: 'pointer'
  },
  fileContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 12,
    borderRadius: 12,
    border: `1px solid ${GRAY_COLORS[200]}`
  },
  fileIcon: {
    position: 'relative'
  },
  blueLines: {
    position: 'absolute',
    top: '55%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  fileWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  actionBtn: { color: theme.palette.primary.main },
  label: { fontWeight: 500 },
  date: { color: GRAY_COLORS[500] },
  chipLike: {
    padding: '6px 10px',
    borderRadius: 8,
    border: `1px dashed ${GRAY_COLORS[300]}`,
    fontSize: 12
  },
  errorField: {
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: `${'#f44336'} !important`
    },
    '& .MuiFormLabel-root': {
      color: '#f44336'
    }
  },
  errorCard: {
    borderColor: `${'#f44336'} !important`
  }
}))
